import React, { Component } from 'react';
import { connect } from 'react-redux'
import {getHostingElementId} from '../../../services/onsiteService';

export class EmbeddedFormContainer extends Component {  

  render () {    
    return (
      <div id={getHostingElementId()} className="hosting-element">      
      </div>
    );
  };
}


function mapStateToProps(state) {
  return {
    hostingElement : state.hostingElement
  };
}
export default connect(mapStateToProps, {})(EmbeddedFormContainer);
